import { AuthGuard } from './auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomePage } from './pages/home/home';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'jpos2021', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'home',
    component: HomePage,
    data: { title: 'home' },
    canActivate: [AuthGuard],
  },
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },
  {
    path: 'work',
    loadChildren: () =>
      import('./main/work/work.module').then((m) => m.WorkModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'setting',
    loadChildren: () =>
      import('./main/setting/setting.module').then((set) => set.SettingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./main/account/account.module').then((acc) => acc.AccountModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'promotion',
    loadChildren: () =>
      import('./main/promotion/promotion.module').then(
        (promotion) => promotion.PromotionModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'system',
    loadChildren: () =>
      import('./main/system-setting/system-setting.module').then(
        (system) => system.SystemSettingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'stock',
    loadChildren: () =>
      import('./main/stock/stock.module').then((stock) => stock.StockModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'report',
    loadChildren: () =>
      import('./main/report/report.module').then(
        (report) => report.ReportModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'icommerce',
    loadChildren: () =>
      import('./main/Icommerce/icommerce.module').then((icom) => icom.IcommerceModule),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
